import { render, staticRenderFns } from "./CreateDropRuleContent.vue?vue&type=template&id=591c71b6&scoped=true&"
import script from "./CreateDropRuleContent.vue?vue&type=script&lang=js&"
export * from "./CreateDropRuleContent.vue?vue&type=script&lang=js&"
import style0 from "./CreateDropRuleContent.vue?vue&type=style&index=0&id=591c71b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591c71b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('591c71b6')) {
      api.createRecord('591c71b6', component.options)
    } else {
      api.reload('591c71b6', component.options)
    }
    module.hot.accept("./CreateDropRuleContent.vue?vue&type=template&id=591c71b6&scoped=true&", function () {
      api.rerender('591c71b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/ModalComponents/CreateDropRuleContent.vue"
export default component.exports